import {
  CharacterCounter,
  StringishInput,
  useSection,
  ValidationErrorMessage,
} from "@tree-company/tree-query";
import { useState } from "react";
import clsx from "clsx";
import t from "../locales";
import { fetchTitles } from "../helpers/utils";

export default function TitleQuestion({ question, className, handleChange }) {
  const { key, title, maxLength, hint, value } = useSection(question);

  const { store } = question;
  const usedAiGeneration = store.getAnswer("used_ai_generation");

  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleGenerate(event) {
    event.preventDefault();

    const who = store.getAnswer("who");
    const what = store.getAnswer("what");
    const where = store.getAnswer("where");
    const why = store.getAnswer("why");

    if (!who || !what || !where || !why) {
      setError(t("createPost.fields.title.generate.missingFields"));
      return;
    }

    setIsLoading(true);
    setError(null);
    setSuggestions([]);

    try {
      const titles = await fetchTitles(who, what, where, why);
      setSuggestions(titles);
      store.setAnswer("used_ai_generation", true);
    } catch {
      setError(t("createPost.fields.title.generate.error"));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={clsx("generation", className)}>
      {/* Title input */}
      <div className="question question--string">
        <label htmlFor={key} className="question__label">
          {title}
        </label>
        <StringishInput question={question} onChange={handleChange} />
        {maxLength && (
          <CharacterCounter
            maxLength={maxLength}
            currentLength={value?.length}
          />
        )}
        {hint && <span className="question__hint">{hint}</span>}
        <ValidationErrorMessage
          question={question}
          className="question__error"
        />
      </div>

      {/* Generate with AI */}
      <div className="generation__header">
        <p className="generation__instruction">
          {t("createPost.fields.title.generate.instruction")}
        </p>
        <div className="generation__container">
          {error && <p className="generation__error">{error}</p>}
          {suggestions.length > 0 ? (
            <ul className="generation__suggestions">
              {suggestions.map((suggestion, index) => (
                <li key={index}>
                  <button
                    type="button"
                    className="generation__suggestion"
                    onClick={() => {
                      question.value = suggestion;
                    }}
                  >
                    {suggestion}
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <button
              type="button"
              className="button generation__button"
              onClick={handleGenerate}
              disabled={isLoading || usedAiGeneration}
            >
              {isLoading ? (
                <span className="generation__spinner" aria-hidden="true" />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M6.275 6.625L3.275 3.625L4.7 2.2L7.7 5.2L6.275 6.625ZM10 4.25V0H12V4.25H10ZM17.275 17.625L14.275 14.625L15.7 13.2L18.7 16.2L17.275 17.625ZM15.7 6.625L14.275 5.2L17.275 2.2L18.7 3.625L15.7 6.625ZM16.65 10.9V8.9H20.9V10.9H16.65ZM3.125 20.6L0.3 17.775C0.1 17.575 0 17.3417 0 17.075C0 16.8083 0.1 16.575 0.3 16.375L9.375 7.275C9.95833 6.69167 10.6667 6.4 11.5 6.4C12.3333 6.4 13.0417 6.69167 13.625 7.275C14.2083 7.85833 14.5 8.56667 14.5 9.4C14.5 10.2333 14.2083 10.9417 13.625 11.525L4.525 20.6C4.325 20.8 4.09167 20.9 3.825 20.9C3.55833 20.9 3.325 20.8 3.125 20.6ZM3.825 18.5L10.1 12.225L8.675 10.825L2.425 17.075L3.825 18.5Z"
                    fill="white"
                  />
                </svg>
              )}
              {t("createPost.fields.title.generate.label")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
